import React from "react";
// import img from '../metaverseassets/buildimg.png';
import "./DappBuild.css";

export default function DappBuild() {
  return (
    <div id="dapp-build" className="marketmainclass">
        <div className="overlay"></div>
        <div className="content">
        <h2 className="heading">
    Plan Your dApp Architecture With Web3 Specialist</h2>
        <button>Schedule your call.</button>
      </div>
   </div>
  );
}
